import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import Button from '../../../../../component/ui/Button';
import { useState } from 'react';
import Modal from '../../../../../component/modal/Modal';
import { toast } from 'react-toastify';
import { createSalesReturn, updateSalesReturn } from '../../../../../services/sales_return';
import usePaymentMethod from '../../../../purchasebills/hooks/usePaymentMethod';
import { getRoundedOff, getRoundedOffAmount } from '../../../components/TaxesCalculation';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../../../../utils/controller';

const CreateSalesReturnHeader = ({
	error,
	setError,
	tableError,
	setTableError,
	salesReturn,
	productTable,
	totalAmount,
	totalDiscountAmount,
	totalTaxesAmount,
	calculateAmount,
	additionDiscountAndTax,
}) => {
	const navigate = useNavigate();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;
	const [loading, setLoading] = useState(false);
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isSalesReturnAutoSave, setIsSalesReturnAutoSave] = useState(false);
	const [isCreateCreditNote, setIsCreateCreditNote] = useState(false);
	const { paymentMethodList } = usePaymentMethod();

	useBlocker((tx) => {
		if (!id && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsSalesReturnAutoSave(true);
			return true;
		}
		return false;
	});

	const checkValidation = (status) => {
		let newError = { ...error };
		let newTableError = [...tableError];
		if (
			!salesReturn.customer_id ||
			salesReturn.customer_id === '' ||
			salesReturn.customer_id === undefined
		) {
			newError.customer_id = 'Please select a valid customer from the list.';
		} else {
			delete newError.customer_id;
		}

		if (
			!salesReturn.sales_return_number ||
			salesReturn.sales_return_number === '' ||
			salesReturn.sales_return_number === undefined
		) {
			newError.sales_return_number = 'Please enter sales return numnber in the field';
		} else {
			delete newError.sales_return_number;
		}

		if (
			!salesReturn.date ||
			salesReturn.date === '' ||
			salesReturn.date === undefined ||
			(salesReturn.date !== '' && newError.date)
		) {
			newError.date = newError.date ?? 'Please enter date in the field';
		} else {
			delete newError.date;
		}

		if (
			!salesReturn.payment_method ||
			salesReturn.payment_method === '' ||
			salesReturn.payment_method === undefined
		) {
			newError.payment_method = 'Please select a valid payment method from the list.';
		} else {
			delete newError.payment_method;
		}
		if (status === 1) {
			productTable.forEach((row, index) => {
				const isRowEmpty =
					!row.product_id &&
					!row.return_type_id &&
					!row.batch_no &&
					(!row.quantity || Number(row.quantity) === 0);

				// 🚨 First row must validate even if empty
				if (index === 0 && isRowEmpty) {
					newTableError.push({ index: 0, name: 'product_id' });
					newTableError.push({ index: 0, name: 'return_type_id' });
					newTableError.push({ index: 0, name: 'batch_no' });
					newTableError.push({ index: 0, name: 'quantity' });
				}

				// Ignore completely empty rows except first
				if (index !== 0 && isRowEmpty) {
					newTableError = newTableError.filter((err) => err.index !== index);
				} else {
					if (!row.product_id) {
						newTableError.push({ index, name: 'product_id' });
					}

					if (!row.return_type_id) {
						newTableError.push({ index, name: 'return_type_id' });
					}

					if (!row.batch_no) {
						newTableError.push({ index, name: 'batch_no' });
					}

					if (!row.quantity || Number(row.quantity) === 0) {
						newTableError.push({ index, name: 'quantity' });
					}
				}
			});
			// if (productTable.length > 0) {
			// 	let productIndex = Number(productTable.length) - 1;
			// 	if (productTable[productIndex].product_id === '') {
			// 		newTableError = [...newTableError, { index: productIndex, name: 'product_id' }];
			// 	} else {
			// 		delete newError.product_id;
			// 	}
			// 	if (
			// 		productTable[productIndex].return_type_id === '' ||
			// 		productTable[productIndex].return_type_id === null ||
			// 		productTable[productIndex].return_type_id === undefined
			// 	) {
			// 		newTableError = [...newTableError, { index: productIndex, name: 'return_type_id' }];
			// 	} else {
			// 		delete newError.return_type_id;
			// 	}
			// 	if (
			// 		productTable[productIndex].batch_no === '' ||
			// 		productTable[productIndex].batch_no === null
			// 	) {
			// 		newTableError = [...newTableError, { index: productIndex, name: 'batch_no' }];
			// 	} else {
			// 		delete newError.batch_no;
			// 	}
			// 	if (
			// 		productTable[productIndex].quantity === '' ||
			// 		productTable[productIndex].quantity === null ||
			// 		Number(productTable[productIndex].quantity) === 0
			// 	) {
			// 		newTableError = [...newTableError, { index: productIndex, name: 'quantity' }];
			// 	} else {
			// 		delete newError.quantity;
			// 	}
			// } else {
			// 	newTableError = [...newTableError, { index: 0, name: 'product_id' }];
			// 	newTableError = [...newTableError, { index: 0, name: 'batch_no' }];
			// 	newTableError = [...newTableError, { index: 0, name: 'quantity' }];
			// 	newTableError = [...newTableError, { index: 0, name: 'return_type_id' }];
			// 	newTableError = [...newTableError, { index: 0, name: 'invoice_number' }];
			// }
		}

		if (Object.keys(newError).length > 0 || newTableError.length > 0) {
			setError(newError);
			setTableError(newTableError);
			return true;
		} else {
			return false;
		}
	};

	async function handleSubmitSalesReturn(status, isCreditNote = false, isLaterRefund = false) {
		const isErrorShow = checkValidation(status);
		if (isErrorShow) {
			toast.error('Please fill all mandatory fields before saving');
		} else {
			try {
				setLoading(true);
				const body = {
					customer_id: salesReturn.customer_id,
					date: salesReturn.date,
					payment_mode_id: salesReturn.payment_method,
					reference: salesReturn.reference,
					notes: salesReturn.notes,
					status: status,
					is_credit_note: isCreditNote,
					is_later_refund: isLaterRefund,
					sub_total: calculateAmount(),
					taxes: totalTaxesAmount(),
					bill_total: getRoundedOffAmount(Number(totalAmount()).toFixed(2)),
					gross_total: calculateAmount(),
					discount: totalDiscountAmount(),
					adjustment: additionDiscountAndTax.adj || 0,
					round_off: getRoundedOff(Number(totalAmount()).toFixed(2)),
					return_number: salesReturn.sales_return_number,
					sales_return_invoices: productTable
						.filter(
							(product) =>
								product.return_type_id !== '' &&
								product.return_type_id !== null &&
								product.invoice_id !== '' &&
								product.invoice_id !== null &&
								product.product_id !== '' &&
								product.product_id !== null &&
								product.quantity !== 0 &&
								product.quantity !== null &&
								product.quantity !== '' &&
								product.mrp !== 0 &&
								product.mrp !== null &&
								product.mrp !== '' &&
								product.amount !== 0 &&
								product.amount !== null &&
								product.amount !== '',
						)
						.map((prod) => {
							const { quantity, mrp, expiry_date, batch_no, product_batch_id, amount, ...rest } =
								prod;
							return {
								...rest,
								qty: Number(quantity),
								mrp: Number(mrp),
								exp: expiry_date,
								product_batch_id: Number(product_batch_id),
								amount: Number(amount),
							};
						}),
				};
				if (id) {
					let res = await updateSalesReturn(id, body);
					if (res.success) {
						toast.success('Sales return updated Successfully');
						navigate(`/user/${suburl}/sales-return`);
					} else {
						toast.error(res.message ?? 'something went wrong');
					}
				} else {
					let res = await createSalesReturn(body);
					if (res.success) {
						toast.success('Sales return Created Successfully');
						setIsLocationBlocker(false);
						setIsSalesReturnAutoSave(false);
						setTimeout(() => {
							navigate(`/user/${suburl}/sales-return`);
						}, 300);
					} else {
						toast.error(res.message ?? 'something went wrong');
					}
				}
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setLoading(false);
			}
		}
	}

	return (
		<div className="product-pg-header add-product header-position-sticky">
			<p>
				{id ? 'Update ' : 'Create New '}
				Sales Return
			</p>
			<div className="add-product-button">
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button={id ? 'Update' : 'Save'}
					loader={loading}
					disabled={
						loading ||
						(id
							? !hasPermission('sales.sales_return.edit', user?.role?.role_permissions)
							: !hasPermission('sales.sales_return.create', user?.role?.role_permissions))
					}
					onClick={() => {
						var list = paymentMethodList.filter(
							(item) =>
								item.key === salesReturn.payment_method &&
								item.value.toLowerCase().includes('credit'),
						);

						if (list.length > 0 && !id) {
							setIsSalesReturnAutoSave(false);
							setIsCreateCreditNote(true);
						} else {
							setIsSalesReturnAutoSave(false);
							handleSubmitSalesReturn(1);
						}
					}}
				/>
				<Button
					type="button"
					className="mt-0 btn-danger add-pro"
					button=""
					close
					onClick={() => navigate(`/user/${suburl}/sales-return`)}
				/>
			</div>
			{isCreateCreditNote && (
				<Modal
					className="deleteVendorsModal"
					title="Create Credit Note"
					isOpen={isCreateCreditNote}
					onClose={() => {
						setIsCreateCreditNote(false);
					}}
					cancelButton={() => {
						setIsCreateCreditNote(false);
					}}
				>
					<p
						style={{
							textAlign: 'center',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							fontSize: '16px',
							color: 'black',
						}}
					>
						Would you like to create a Credit Note now?
					</p>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
							marginTop: '10px',
						}}
					>
						<Button
							type="button"
							button="Create Credit Note"
							disabled={!hasPermission('sales.credit_notes.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsCreateCreditNote(false);
								handleSubmitSalesReturn(1, true, false);
							}}
						/>

						<Button
							type="button"
							button="Later"
							disabled={!hasPermission('sales.sales_return.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsCreateCreditNote(false);
								handleSubmitSalesReturn(1, false, true);
							}}
						/>
					</div>
				</Modal>
			)}
			{isSalesReturnAutoSave && (
				<Modal
					className="deleteVendorsModal"
					title="Sales Return Auto Save"
					isOpen={isSalesReturnAutoSave}
					onClose={() => {
						setIsSalesReturnAutoSave(false);
					}}
					cancelButton={() => {
						setIsSalesReturnAutoSave(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						You have unsaved changes. Do you want to continue without saving?
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Leave Without Saving"
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsLocationBlocker(false);
								setIsSalesReturnAutoSave(false);
								setTimeout(() => {
									navigate(isNextLocation.nextLocation?.pathname);
								}, 300);
							}}
						/>

						<Button
							type="button"
							button="Save and Continue"
							disabled={!hasPermission('sales.sales_return.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsSalesReturnAutoSave(false);
								handleSubmitSalesReturn(1);
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};
export default CreateSalesReturnHeader;
